document.addEventListener('DOMContentLoaded', () => {

    const displaySection = document.querySelector('.wp-block-wm-cardioline-scrollable-display-section');

    

    const framesSplide = new Splide( displaySection.querySelector('.splide.-display-section-frames') );
    const buttonsSplide = new Splide( displaySection.querySelector('.splide.-display-section-buttons') );
    
    framesSplide.sync( buttonsSplide );
    framesSplide.mount();
    buttonsSplide.mount();

    const textElement = displaySection.querySelector('.wp-block-wm-cardioline-scrollable-display-section__inner');
    
    const buttons = displaySection.querySelectorAll('[data-frame-target]');

    const isMobileScreen = () => window.innerHeight <= textElement.offsetHeight || window.innerWidth < 768;

    if (isMobileScreen()) {
        buttons.forEach(button => {
            button.addEventListener('mouseover', () => {
                buttons.forEach( (button) => {
                    button.classList.remove('-active');
                });
                const target = button.getAttribute('data-frame-target');
                button.classList.add('-active');
                framesSplide.go(parseInt(target));
            });
        });
        displaySection.classList.add('-mobile');
    } else {
        displaySection.classList.remove('-mobile');
    }
    window.addEventListener('resize', () => {
        if (isMobileScreen()) {
            buttons.forEach(button => {
                button.addEventListener('mouseover', () => {
                    const target = button.getAttribute('data-frame-target');
                    button.classList.add('-active');
                    framesSplide.go(parseInt(target));
                });
                button.addEventListener('mouseout', () => {
                    button.classList.remove('-active');
                    framesSplide.go(0);
                });
            });
            displaySection.classList.add('-mobile');
        } else {
            displaySection.classList.remove('-mobile');
        }
    });

    window.addEventListener('scroll', () => {

        if ( isMobileScreen() ) {
            
            return;
        }
        const containerRect = displaySection.getBoundingClientRect();
        const containerTop = containerRect.top;
        const containerBottom = containerRect.bottom;
        const textHeight = textElement.offsetHeight;

        if (containerTop <= 0 && containerBottom >= textHeight) {
            // Element is in viewport, fix it
            textElement.style.position = 'fixed';
            textElement.style.top = '0';


            let offsetSectionHeight = displaySection.offsetHeight - textHeight;

            if ( containerTop > offsetSectionHeight * -.25 ) {
                buttons.forEach( (button) => {
                    button.classList.remove('-active');
                });
                const button = displaySection.querySelector('a[data-frame-target="0"]');
                button.classList.add('-active');
                framesSplide.go(0);
            } else if ( containerTop < offsetSectionHeight * -.25 && containerTop > offsetSectionHeight * -.5  ) {
                buttons.forEach( (button) => {
                    button.classList.remove('-active');
                });
                const button = displaySection.querySelector('a[data-frame-target="1"]');
                button.classList.add('-active');
                framesSplide.go(1);
            } else if ( containerTop < offsetSectionHeight * -.5 && containerTop > offsetSectionHeight * -.75  ) {
                buttons.forEach( (button) => {
                    button.classList.remove('-active');
                });
                const button = displaySection.querySelector('a[data-frame-target="2"]');
                button.classList.add('-active');
                framesSplide.go(2);
            } else if ( containerTop < offsetSectionHeight * -.75 && containerTop > offsetSectionHeight * -1 ) {
                buttons.forEach( (button) => {
                    button.classList.remove('-active');
                });
                const button = displaySection.querySelector('a[data-frame-target="3"]');
                button.classList.add('-active');
                framesSplide.go(3);
            }
            
            
        } else if (containerBottom < textHeight) {
            // Reached bottom of container, stick to bottom
            textElement.style.position = 'absolute';
            textElement.style.top = (displaySection.offsetHeight - textHeight) + 'px';
        } else {
            // Above container, release
            textElement.style.position = 'relative';
            textElement.style.top = '0';
        }
    });
});